<script lang="ts">
    import {onMount} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import {fade} from 'svelte/transition';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';

    export let imageElement: HTMLImageElement;
    export let loadersScale = 1;

    let loading = true;
    let loadError = false;

    onMount(() => {
        if (exists(imageElement) && imageElement.complete) {
            loading = false;
        }
    });

    function onLoadSuccess() {
        loading = false;
    }

    function onLoadError() {
        loading = false;
        loadError = true;
    }
</script>

<div class="mv-loadable-image" style:--loaders-scale="{loadersScale}">
    <slot {onLoadSuccess} {onLoadError} {loading} {loadError}/>

    {#if loading}
        <div class="thumbnail-loader-container" out:fade={{duration: 150}}>
            <KpLoadingBlock size="xs"/>
        </div>
    {/if}

    {#if loadError}
        <div class="thumbnail-loader-container" in:fade={{duration: 150}}>
            <UIcon color="var(--danger-red)" icon="exclamation"/>
        </div>
    {/if}
</div>

<style lang="less">
    .mv-loadable-image {
        position: relative;

        .thumbnail-loader-container {
            scale: var(--loaders-scale);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>